// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"LoadingIndicator_loadingIndicator__rkjs4"};